import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../utils/api";
import "../panel/userPanel.css";

export default function UploadVideo() {
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));

  const userId = user?._id;
  const channelId = user?.channelId;

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [hashtags, setHashtags] = useState("");
  const [visibility, setVisibility] = useState(1);

  const [videoFile, setVideoFile] = useState(null);
  const [thumbnailFile, setThumbnailFile] = useState(null);

  const [videoPreview, setVideoPreview] = useState(null);
  const [thumbnailPreview, setThumbnailPreview] = useState(null);

  const [loading, setLoading] = useState(false);

  // ?? video select
  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    setVideoFile(file);
    if (file) setVideoPreview(URL.createObjectURL(file));
  };

  // ??? thumbnail select
  const handleThumbnailChange = (e) => {
    const file = e.target.files[0];
    setThumbnailFile(file);
    if (file) setThumbnailPreview(URL.createObjectURL(file));
  };

  // ?? duration ????? (IMPORTANT)
  const getVideoDuration = (file) => {
    return new Promise((resolve) => {
      const video = document.createElement("video");
      video.preload = "metadata";

      video.onloadedmetadata = () => {
        window.URL.revokeObjectURL(video.src);
        resolve(Math.floor(video.duration));
      };

      video.src = URL.createObjectURL(file);
    });
  };

  // ?? upload video
  const uploadVideo = async () => {
    const formData = new FormData();
    formData.append("content", videoFile);
    formData.append("folderStructure", "sharevideo/Videos"); // ? FIX

    const res = await api.put("/client/file/upload-file", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data?.data || res.data?.url || res.data;
  };

  // ??? upload thumbnail
  const uploadThumbnail = async () => {
    const formData = new FormData();
    formData.append("content", thumbnailFile);
    formData.append("folderStructure", "sharevideo/videoImage"); // ? FIX

    const res = await api.put("/client/file/upload-file", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data?.data || res.data?.url || res.data;
  };

  // ?? final upload
  const handleUpload = async () => {
    if (!title || !description || !hashtags || !videoFile || !thumbnailFile) {
      alert("Please fill all required fields");
      return;
    }

    if (!userId || !channelId) {
      alert("Channel not created. Please create channel first.");
      return;
    }

    try {
      setLoading(true);

      // ?? FIX: duration
      const duration = await getVideoDuration(videoFile);

      if (!duration || duration <= 0) {
        alert("Invalid video duration");
        return;
      }

      const hashTagArray = hashtags
        .split(" ")
        .map((tag) => tag.replace("#", "").trim())
        .filter(Boolean);

      const videoUrl = await uploadVideo();
      const thumbnailUrl = await uploadThumbnail();

      console.log("FINAL:", { videoUrl, thumbnailUrl, duration });

      await api.post("/client/video/createVideo", {
        title,
        description,
        hashTag: hashTagArray,
        videoType: 1,
        videoTime: duration, // ?? FIX
        visibilityType: visibility,
        audienceType: 1,
        commentType: 1,
        scheduleType: 2,
        location: "",
        latitude: "0",
        longitude: "0",
        userId,
        channelId,
        fullName: user?.fullName || "",
        descriptionOfChannel: "",
        videoUrl,
        videoImage: thumbnailUrl,
        videoPrivacyType: visibility,
        channelType: "1",
        isShort: false,
      });

      alert("Video uploaded successfully");
      navigate("/user/videos-feed");

    } catch (err) {
      console.error("Upload error:", err?.response?.data || err);
      alert("Video upload failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="upload-container">
      <div className="upload-card">
        <h2>Upload Video</h2>

        <div className="form-group">
          <label>Title *</label>
          <input
            type="text"
            className="form-input"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Description *</label>
          <textarea
            className="form-textarea"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Hashtags *</label>
          <input
            type="text"
            className="form-input"
            value={hashtags}
            onChange={(e) => setHashtags(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Thumbnail *</label>
          <input type="file" accept="image/*" onChange={handleThumbnailChange} />
          {thumbnailPreview && (
            <img src={thumbnailPreview} style={{ width: "100%", marginTop: 10 }} />
          )}
        </div>

        <div className="form-group">
          <label>Video *</label>
          <input type="file" accept="video/*" onChange={handleVideoChange} />
          {videoPreview && (
            <video src={videoPreview} controls style={{ width: "100%", marginTop: 10 }} />
          )}
        </div>

        <div className="form-group">
          <label>Visibility</label>
          <select
            value={visibility}
            onChange={(e) => setVisibility(Number(e.target.value))}
          >
            <option value={1}>Public</option>
            <option value={2}>Private</option>
            <option value={3}>Unlisted</option>
          </select>
        </div>

        <button onClick={handleUpload} disabled={loading}>
          {loading ? "Uploading..." : "Upload Video"}
        </button>
      </div>
    </div>
  );
}